import React from 'react';
import { Box } from '@rebass/grid';
import { Link, Typography } from '@material-ui/core';
import { scrims } from '../../config/theme';

const baseBodyStyle = {
  whiteSpace: 'pre-wrap',
  overflowWrap: 'break-word',
  wordBreak: 'break-word',
};

const truncatedStyle = {
  ...baseBodyStyle,
  display: '-webkit-box',
  WebkitLineClamp: 3,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

const PostContent = ({ post, truncateBody }) => {
  return (
    <>
      {!!post.image_url && (
        <Box
          mb="16px"
          style={{
            display: 'flex',
            justifyContent: 'center',
            background: scrims.soft,
            borderRadius: '8px',
          }}
        >
          <img
            src={post.image_url}
            alt={post.title || 'News post image'}
            style={{
              maxWidth: '100%',
              maxHeight: '320px',
              borderRadius: '8px',
              display: 'block',
            }}
          />
        </Box>
      )}
      <Typography variant="body1" style={truncateBody ? truncatedStyle : baseBodyStyle}>
        {post.body || post.content || post.description}
      </Typography>
      {Array.isArray(post.links) && post.links.length > 0 && (
        <Box mt="16px">
          {post.links.map((linkValue) => (
            <Box key={linkValue} mb="6px">
              <Link
                href={linkValue}
                target="_blank"
                rel="noreferrer"
                onClick={(event) => event.stopPropagation()}
              >
                {linkValue}
              </Link>
            </Box>
          ))}
        </Box>
      )}
    </>
  );
};

export default PostContent;
